/* Map drag selection guard — port of the selection guard in the toolkit's
   mobile-map-gestures.js (map-polish module, #1046 Wave A).

   The map pane is user-select:none (explorer.css), but a drag that starts on
   the map and travels past its edge would still paint text selection across
   the rest of the explorer — the property cards next to a side-by-side map
   are the usual victim. While a pointer that went down inside the pane is
   held, the .hfse wrapper carries `hfse-map-drag` (unselectable via the
   matching CSS rule); it is removed the moment the pointer lifts, so card
   text stays copyable in every other situation.

   Wired as the pane's onPointerDown rather than a document-level capture
   listener as the toolkit does: the widget renders inside a shadow root, and
   a document listener would see the event RETARGETED to the host element —
   `closest('.hfse-map')` could never match. The release listeners go on
   window, which needs no target: a drag that ends outside the widget still
   lifts the guard. */

const DRAG_CLASS = 'hfse-map-drag'

export function beginMapDragGuard(paneEl: HTMLElement): void {
  const root = paneEl.closest('.hfse')
  if (!root || root.classList.contains(DRAG_CLASS)) return
  root.classList.add(DRAG_CLASS)
  const release = () => {
    root.classList.remove(DRAG_CLASS)
    window.removeEventListener('pointerup', release, true)
    window.removeEventListener('pointercancel', release, true)
  }
  window.addEventListener('pointerup', release, true)
  window.addEventListener('pointercancel', release, true)
}
